<script>
    import {links, navigate} from "svelte-routing";
    import ContentListComponent from "../Contents/ContentListComponent.svelte";
    import {afterUpdate, onMount} from "svelte";
    import SvelteSeo from "svelte-seo";
    import {decode} from "html-entities";
    import HeaderImageComponent from "../Contents/Files/HeaderImageComponent.svelte";
    import CustomContentViewItemComponent from "../Contents/CustomContentViewItemComponent.svelte";
    import ChildPagesComponent from "./ChildPagesComponent.svelte";

    export let config;
    export let minfo;

    $ : mid = minfo.match(/-m-(\d)+/g)[0].split(/m-/)[1];

    $ : menuItem = loadMenuItem(mid);
    $ : childItems = loadChildItems(mid);

    $ : mname = "";

    function loadMenuItem(id) {
        return fetch(config.model_root + 'shared/menu/load_menu_item.php?mid=' + id, {
            method: "GET"
        })
            .then(response => response.json())
            .then((data) => {
                mname = data[0].mname;
                return data;
            });
    }

    function loadChildItems(id) {
        return fetch(config.model_root + 'shared/menu/load_child_items.php?mid=' + id, {
            method: "GET"
        })
            .then(response => response.json());
    }

</script>

<svelte:head>
    <title>{decode(mname)}</title>
</svelte:head>

<SvelteSeo
        title="{decode(mname)}"
        description="Herzlich Willkommen im Dorfladen Gungolding! Entdecken Sie frische, regionale Produkte von unseren Lieferanten wie Hainmühle, Metzgerei Gehr und Bäckerei Bauer. Qualität und Nachhaltigkeit stehen bei uns an erster Stelle. Wir freuen uns auf Ihren Besuch!"
        keywords="Dorfladen Gungolding, regionale Produkte, frische Lebensmittel, nachhaltige Erzeugnisse, lokale Spezialitäten, Obst und Gemüse, handwerkliche Backwaren, Hainmühle, Metzgerei Gehr, Bäckerei Bauer, Bio Kartoffeln, Imkerei"
        openGraph={{
            title: `${mname}`,
            description: 'Herzlich Willkommen im Dorfladen Gungolding! Entdecken Sie frische, regionale Produkte von unseren Lieferanten wie Hainmühle, Metzgerei Gehr und Bäckerei Bauer. Qualität und Nachhaltigkeit stehen bei uns an erster Stelle. Wir freuen uns auf Ihren Besuch!',
            url: `https://www.dorfladen-gungolding.de/site/${minfo}`,
            type: 'website',
            images: [
              {
                url: 'https://www.dorfladen-gungolding.de/images/LOGO.JPG',
                width: 1141,
                height: 433,
                alt: 'Heimat und Genuss - Dorfladen Gungolding'
              }
             ]
          }}
/>

<div class="container site-content" use:links>

    {#await menuItem}
        <p class="alert alert-light">
            <i class="fas fa-circle-notch fa-spin me-1"></i> Seite wird geladen...
        </p>
    {:then data}

        <div class="row">

            <div class="col">
                <div class="site-section px-4 py-4 rounded">

                    {#if data[0].mtype == "TYPE_DEFAULT"}
                        <ContentListComponent {config} {mid} mname={data[0].mname} viewOptions="{
                            {
                                sort_by: data[0].msort,
                                detail_view_settings: data[0].mdetail_view_settings,
                                view: data[0].mview,
                                placement_non_pinned: data[0].mplacement_non_pinned,
                                show_date: data[0].mshow_date,
                                show_author: data[0].mshow_author
                            }
                        }"/>
                    {:else}
                        <CustomContentViewItemComponent {config} {mid} mtype={data[0].mtype} mname={mname}/>
                    {/if}

                    <ChildPagesComponent {config} {mid} />
                </div>
            </div>

        </div>


    {:catch error}
        {navigate("/not-found", {replace: false})}
    {/await}

</div>

<style>
    h1 {
        font-size: 20px;
    }

    :global(.site-content) {
        margin-top: 11px;
        font-family: 'Roboto Condensed', sans-serif;
    }

    :global(.site-section) {
        background-color: rgba(255, 255, 255, 0.85);
        /*background-color: #fff;*/
    }

    .submenu * {
        text-align: left;
    }
</style>
